import { selectBalancingFarmEventById } from "../balancingSelectors/selectBalancingFarmEvents";
import { selectBalancingPackageById } from "../balancingSelectors/selectBalancingPackages";
import { selectBalancingRandomPool } from "../balancingSelectors/selectBalancingRandomPools";
import { IdEvent } from "../constants/IdEvents";
import { selectEventEndTime, selectEventInfoByTypeId, selectIsEventRunning } from "./selectEventInfo";
import { selectPlayerLevel } from "./selectPlayerLevelInfo";
export var selectFortuneTellerEventDetails = function (state) {
    return state.eventInfo.fortuneTellerEvent;
};
export var selectFortuneTellerEventRemainingTime = function (state) {
    var fortuneTellerEventDetails = selectFortuneTellerEventDetails(state);
    if (fortuneTellerEventDetails && fortuneTellerEventDetails[0]) {
        return selectEventEndTime(fortuneTellerEventDetails[0]);
    }
    return 0;
};
export var selectIsFortuneTellerEventRunning = function (state) {
    var eventInfo = selectEventInfoByTypeId(state, IdEvent.FortuneTeller);
    if (eventInfo) {
        return selectIsEventRunning(eventInfo.proto);
    }
    return false;
};
export var selectIsFortuneTellerEventPackage = function (state, packageId) {
    var packageDetails = selectFortuneTellerEventPackageDetails(state);
    return packageDetails != undefined && packageDetails.currentPackageId === packageId;
};
export var selectFortuneTellerEventProgress = function (state) {
    var totalChances = 0;
    var fortuneTellerEventBalancingDetails = selectBalancingFarmEventById(IdEvent.FortuneTeller);
    var _a = state.fortuneTellerEventInfo, currentStep = _a.currentStep, difficulty = _a.difficulty;
    if (fortuneTellerEventBalancingDetails && fortuneTellerEventBalancingDetails.difficultyLevel) {
        var currentDifficultyLevel = fortuneTellerEventBalancingDetails.difficultyLevel[difficulty];
        totalChances = currentDifficultyLevel.packageReward.length;
    }
    return { currentStep: currentStep, totalChances: totalChances };
};
export var selectIsPlayerQualifiedForFortuneTellerEvent = function (state) {
    var fortuneTellerEventBalancingDetails = selectBalancingFarmEventById(IdEvent.FortuneTeller);
    var level = selectPlayerLevel(state);
    return !!(fortuneTellerEventBalancingDetails &&
        fortuneTellerEventBalancingDetails.requPlayerLevel <= level);
};
export var selectFortuneTellerEventPackageDetails = function (state) {
    var fortuneTellerEventBalancingDetails = selectBalancingFarmEventById(IdEvent.FortuneTeller);
    var _a = state.fortuneTellerEventInfo, currentStep = _a.currentStep, difficulty = _a.difficulty;
    if (fortuneTellerEventBalancingDetails && fortuneTellerEventBalancingDetails.difficultyLevel) {
        var currentDifficultyLevel = fortuneTellerEventBalancingDetails.difficultyLevel[difficulty];
        if (currentDifficultyLevel &&
            currentDifficultyLevel.packageReward &&
            currentStep < currentDifficultyLevel.packageReward.length) {
            var currentPackageId = currentDifficultyLevel.packageReward[currentStep].packageId;
            var balancingPackage = selectBalancingPackageById(currentPackageId);
            if (balancingPackage && balancingPackage.randomPoolReward && balancingPackage.cost) {
                var randomPoolRewardId = balancingPackage.randomPoolReward[0].randomPoolId;
                var cost = balancingPackage.cost[0];
                var randomPool = selectBalancingRandomPool(randomPoolRewardId);
                if (randomPool &&
                    randomPool.poolContent &&
                    randomPool.poolContent[0].resourceReward) {
                    var bestRandomReward = randomPool.poolContent[0].resourceReward[0];
                    return {
                        bestRandomReward: bestRandomReward,
                        cost: cost,
                        currentPackageId: currentPackageId,
                        randomPoolRewardId: randomPoolRewardId,
                    };
                }
            }
        }
    }
    return;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectFortuneTellerEventInfo.ts
// module id = 246
// module chunks = 3